import React, { useEffect, useState } from "react";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { Card, CardBody, Col, Container, Button, Row } from "reactstrap";
import { Link } from "react-router-dom";
import SweetAlert from "react-bootstrap-sweetalert";
import { CheckPermission } from "../Permissions/CheckPermissions";
import { FaPen , FaRegTrashAlt, FaPlus, FaCloudUploadAlt} from "react-icons/fa";

const MenuLabels = (props) => {
  const sortOptions = [
    { id: 1, value: "enabled", label: "Enabled" },
    { id: 2, value: "all", label: "All" },
  ];
  const [sortBy, setSortBy] = useState(sortOptions[0].value);
  const [token, setToken] = useState();
  const [data, setData] = useState([]);
  const [del, setDelete] = useState(false);
  const [successAlert, setSuccesAlert] = useState(false);
  const [ItemForDelete, setItemForDelete] = useState("initialState");
  const [errorAlert, setErrorAlert] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem("AuthenticationToken");
    setToken(token);
    getMenuLabels(token);
  }, []);

  const getMenuLabels = (token) => {
    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);
    myHeaders.append(
      "Cookie",
      "__cfduid=d5b74235daa6f013fde0aba762ec288811620640208"
    );

    var requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    fetch(
      `${process.env.REACT_APP_TOKRI_API_URL}/api/frhub?path=menu_labels&env=production`,
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        //Sorting Method
       const sortedArray = result?.labelsData.sort((a, b) => {         
        return a.sort_order - b.sort_order;        
    })
        setData(sortedArray);
      })
      .catch((error) => console.log(" errror", error));
  };

  const handleConfirmation = () => {
    return (
      <SweetAlert
        title="Warning"
        warning
        showCancel={true}
        showConfirm={true}
        btnSize="lg"
        confirmBtnText="Delete"
        confirmBtnBsStyle="success"
        cancelBtnBsStyle="secondary"
        onConfirm={() => {
          deleteEntry(ItemForDelete?.item_id, token);
          setDelete(false);
          // props?.history.push(`/carousel-banners/estore`)
          // setsuccess_msg(false)
        }}
        onCancel={() => setDelete(false)}
        show={true}
      >
        {"Are you sure you want to delete ?"}
      </SweetAlert>
    );
  };
  const renderSuccessAlert = () => {
    return (
      <SweetAlert
        title="Success!"
        success
        confirmBtnBsStyle="success"
        onConfirm={() => {
          props.history.go(0);
          setSuccesAlert(false);
        }}
        onCancel={() => {
          setSuccesAlert(false);
        }}
      >
        {"Menu Label deleted successfully."}
      </SweetAlert>
    );
  };

  const renderFailureAlert = () => {
    return (
      <SweetAlert
        title="Warning!"
        warning
        confirmBtnBsStyle="warning"
        onConfirm={() => {
          setErrorAlert(false);
        }}
      >
        {"Error. Something went wrong."}
      </SweetAlert>
    );
  };

  const deleteEntry = (ID, token) => {
    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    fetch(
      `${process.env.REACT_APP_TOKRI_API_URL}/api/frhub?path=menu_labels/delete&id=${ID}`,
      requestOptions
    )
      .then((response) => {
        if (response.status == 200) {
          setSuccesAlert(true);
        } else {
          setErrorAlert(true);
        }
        response.text();
      })
      .then((result) => console.log(result))
      .catch((error) => console.log("error", error));
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs breadcrumbItem="Menu Labels" />
          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  <Row>
                    <Col lg={6} md={12} sm={12}>
                      <Button
                         disabled={!CheckPermission("menu_labels","add")}
                        className="btn btn-success waves-effect waves-light"
                        onClick={() => {
                          props?.history?.push("/add-menu-label");
                        }}
                      >
                        <FaPlus size={12} /> Add Menu label
                      </Button>
                    </Col>
                    <Col lg={6} md={12} sm={12} style={{ textAlign: "right" }}>
                      <div className="mb-3">
                        {/* <Label>Discount Type</Label> */}
                        <label htmlFor="cars">Status</label>

                        <select
                          name="cars"
                          defaultValue={sortOptions[0].value}
                          id="cars"
                          onChange={(e) => {
                            setSortBy(e.target.value);
                          }}
                          style={{ width: 80, height: 30, marginLeft: 10 }}
                          options={sortOptions}
                        >
                          {sortOptions?.map((item, index) => {
                            return (
                              <option key={index} value={item.value}>
                                {item.label}
                              </option>
                            );
                          })}
                        </select>
                      </div>
                    </Col>
                  </Row>
                  <div className="table-responsive mt-3">
                    <table
                      style={{}}
                      className="table table-bordered border-primary mb-0"
                    >
                      <thead>
                        <tr>
                          <th>Label Name</th>
                          <th>Selected Image</th>
                          <th>Un Selected Image</th>
                          <th style={{width:"8%"}}>Order</th>
                          <th style={{width:"8%"}}>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {data?.map((item, index) => {
                          return (
                            <tr key={index}>
                              <td>{item.item_name}</td>
                              <td>
                                <img
                                  src={item?.userfile}
                                  style={{ width: 50 }}
                                  alt=""
                                />
                              </td>
                              <td style={{background:"rgb(244, 106, 106)"}}>
                                <img
                                  src={item?.unselectedFile}
                                  style={{ width: 50 }}
                                  alt=""
                                />
                              </td>
                              <td>{item.sort_order}</td>
                              <td>
                                <Row>
                                  <div className="d-flex justify-content-around">
                                  {  CheckPermission("menu_labels","update")&&<div
                                      style={{ width: 30, textAlign: "center" }}
                                      className="text-primary"
                                    >
                                      <a
                                        className="uil uil-pen font-size-18"
                                        onClick={() => {
                                          props?.history?.push("/add-menu-label", {
                                            edit: true,
                                            item: item,
                                          });
                                        }}
                                      ></a>
                                    </div>}

                                    {CheckPermission("menu_labels","delete") && <div style={{ width: 30 }}>
                                      <Link to="#" className="px-3 text-danger">
                                        <i
                                          className="uil uil-trash-alt font-size-18"
                                          onClick={() => {
                                            setItemForDelete(item);
                                            setDelete(true);
                                          }}
                                        ></i>
                                      </Link>
                                    </div>}
                                  </div>
                                </Row>
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
          {del ? handleConfirmation() : null}
          {successAlert ? renderSuccessAlert() : null}
          {errorAlert ? renderFailureAlert() : null}
        </Container>
      </div>
    </React.Fragment>
  );
};

export default MenuLabels;
